import AppBar from '@material-ui/core/AppBar'
import { withStyles } from '@material-ui/core/styles'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { selectCurrentOrganization } from '../../../../selectors/dobovoSelectors/dobovoCurrentOrganization'
import ApartmentsTab from './ApartmentsTab'
import CurrentOrganization from './CurrentOrganization'
import OrganizationTab from './OrganizationTab'
import SyncTab from './SyncTab'

const TabContainer = props => (
    <Typography component="div" style={{ padding: 8 * 3, backgroundColor: '#f5f5f5' }}>
        {props.children}
    </Typography>
)

TabContainer.propTypes = {
    children: PropTypes.node.isRequired
}

const styles = theme => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper
    },
    tabs: {
        flex: 1
    },
    toolbarContent: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        width: '100%'
    },
    '@media (max-width: 720px)': {
        toolbarContent: {
            flexDirection: 'column',
            alignItems: 'center'
        }
    },
    typographyContainer: {
        padding: '50px 0',
        backgroundColor: '#f5f5f5'
    }
})

class MappingTabs extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired
    }

    state = { value: 0 }

    handleChange = (event, value) => {
        this.setState({ value })
    }

    render() {
        const { classes, currentOrganization } = this.props
        const { value } = this.state

        return (
            <div className={classes.root}>
                <AppBar position="static" color="default">
                    <Toolbar>
                        <div className={classes.toolbarContent}>
                            <Tabs value={value} onChange={this.handleChange} className={classes.tabs}>
                                <Tab label="Организации" />
                                <Tab label="Апартаменты" />
                                <Tab label="Синхронизация" />
                            </Tabs>
                            <CurrentOrganization />
                        </div>
                    </Toolbar>
                </AppBar>

                {value === 0 ? (
                    <TabContainer>
                        <OrganizationTab />
                    </TabContainer>
                ) : currentOrganization ? (
                    <Fragment>
                        {value === 1 && (
                            <TabContainer>
                                <ApartmentsTab />
                            </TabContainer>
                        )}
                        {value === 2 && (
                            <TabContainer>
                                <SyncTab />
                            </TabContainer>
                        )}
                    </Fragment>
                ) : (
                    <div className={classes.typographyContainer}>
                        <Typography variant="subheading" align="center">
                            Огранизация не выбрана. Пожалуйста, выберите организацию!
                        </Typography>
                    </div>
                )}
            </div>
        )
    }
}

export default connect(state => ({ currentOrganization: selectCurrentOrganization(state) }))(
    withStyles(styles)(MappingTabs)
)



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/DobovoTab/MappingTabs/MappingTabs.js